import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import apiResponse from '../../../../services/apiResponse'
import CreateBloc from './Blocs/CreateBloc'
import { accessRole } from "../../../../helpers/access_role"

var reformatOptionType = function(regions) {
    return regions.map(function(region) {
        var newObj = {};
        newObj["label"] = region.punishment_type_name;
        newObj["value"] = region.punishment_type_uuid;
        return newObj;
    });
};

var reformatOptionSignatory = function(regions) {
    return regions.map(function(region) {
        var newObj = {};
        newObj["label"] = region.signatories_official_position+' - '+region.signatories_official_nip+" - "+region.signatories_official_name;
        newObj["value"] = region.signatories_official_uuid;
        return newObj;
    });
};

var reformatOptionParent = function(regions) {
    return regions.map(function(region) {
        var newObj = {};
        newObj["label"] = region.punishment_type_name_tabs;
        newObj["value"] = region.punishment_uuid;
        return newObj;
    });
};

class IndexView extends Component {

    createBloc = new CreateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {
                punishment_name:"",
                activeSelected: ""
            },
            typeItems: [],
            typeSelected: "",
            parentItems: [],
            parentSelected: "",
            signatoryItems:[],
            signatorySelected:""
        }
    }

    submitData = async () => {
        const formData = generateFormData(this.state.dataForm) // 'document' disini adalah nama field FileInput. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
        await this.createBloc.fetchCreate(formData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              ...values
            },
            confirm: true
        })
    }

    onChangeActive = (event) => {
        const target = event.target;
        const value = target.checked ? 1 : 0
        this.setState({
            //
            activeSelected: value
        });
    }

    onChangeType = (typeSelected) => {
        this.setState({
            typeSelected: typeSelected.value
        });
    }

    onChangeParent = (parentSelected) => {
        this.setState({
            parentSelected: parentSelected.value
        });
    }

    onChangeSignatory = (signatory) => {
        this.setState({
            sigantorySelected: signatory.value,
        });
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {

        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.createBloc.typeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response                        
                        this.setState({
                            typeItems: reformatOptionType(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.createBloc.signatoryChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response                        
                        this.setState({
                            signatoryItems: reformatOptionSignatory(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.createBloc.parentChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response                        
                        this.setState({
                            parentItems: reformatOptionParent(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.createBloc.fetchSignatory()
        this.createBloc.fetchParent()
        this.createBloc.fetchType()

    }

    

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                           

                            <Card className="">
                                <CardBody>
                                    <CardTitle>Tambah Data Hukuman Disiplin</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama Hukuman <span className="text-danger">*</span>
                                            </label>
                                            <Col md="8">
                                                <AvField
                                                    name="punishment_name"
                                                    placeholder="Nama Hukuman..."
                                                    type="text"
                                                    errorMessage="Masukkan Nama Hukuman"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="punishment_name"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tingkatan Hukuman <span className="text-danger">*</span>
                                            </label>
                                            <Col md="8">
                                                <Select
                                                    value={this.state.parentItems.filter(option => 
                                                      option.value === this.state.parentSelected)}
                                                    onChange={
                                                      this.onChangeParent
                                                    }
                                                    required="required"
                                                    placeholder="Tingkatan Hukuman..."
                                                    options={this.state.parentItems}
                                                    classNamePrefix=""
                                                />
                                                <AvField
                                                    name="punishment_parent_uuid"
                                                    type="hidden"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="punishment_parent_uuid"
                                                    value={this.state.parentSelected}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jenis Hukuman <span className="text-danger">*</span>
                                            </label>
                                            <Col md="8">
                                                <Select
                                                    value={this.state.typeItems.filter(option => 
                                                      option.value === this.state.typeSelected)}
                                                    onChange={
                                                      this.onChangeType
                                                    }
                                                    required="required"
                                                    placeholder="Jenis Hukuman..."
                                                    options={this.state.typeItems}
                                                    classNamePrefix=""
                                                />
                                                <AvField
                                                    name="punishment_type_uuid"
                                                    type="hidden"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="punishment_type_uuid"
                                                    value={this.state.typeSelected}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            No SK <span className="text-danger">*</span>
                                            </label>
                                            <Col md="8">
                                                <AvField
                                                    name="punishment_no_sk"
                                                    placeholder="Nomor SK..."
                                                    type="text"
                                                    errorMessage="Masukkan Nomor SK"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="punishment_no_sk"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal SK <span className="text-danger">*</span>
                                            </label>
                                            <Col md="8">
                                                 <AvField
                                                    name="punishment_tgl_sk"
                                                    placeholder="Tanggal SK..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal SK"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="punishment_tgl_sk"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            TMT SK <span className="text-danger">*</span>
                                            </label>
                                            <Col md="8">
                                                <AvField
                                                    name="punishment_tmt_sk"
                                                    placeholder="TMT SK..."
                                                    type="date"
                                                    errorMessage="Masukkan TMT SK"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="punishment_tmt_sk"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Permasalahan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="8">
                                                <AvField
                                                    name="punishment_problem"
                                                    placeholder="Permasalahan..."
                                                    type="textarea"
                                                    errorMessage="Masukkan Permasalahan"
                                                    className="form-control"
                                                    rows="8"
                                                    validate={{ required: { value: true } }}
                                                    id="punishment_problem"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Pejabatan Penetap <span className="text-danger">*</span>
                                            </label>
                                            <Col md="8">
                                                <Select
                                                    value={this.state.signatoryItems.filter(option => 
                                                      option.value === this.state.sigantorySelected)}
                                                    onChange={
                                                      this.onChangeSignatory
                                                    }
                                                    required="required"
                                                    placeholder="Pejabat Penetap..."
                                                    options={this.state.signatoryItems}
                                                    classNamePrefix=""
                                                />
                                                <AvField
                                                    name="punishment_signatory_uuid"
                                                    type="hidden"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="punishment_signatory_uuid"
                                                    value={this.state.sigantorySelected}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Berlaku <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                <input
                                                    name="active_selected"
                                                    type="checkbox"
                                                    checked={this.state.isChecked}
                                                    onChange={this.onChangeActive} 
                                                />
                                                <AvField
                                                    name="punishment_is_active_selected"
                                                    type="hidden"
                                                    id="punishment_is_active_selected"
                                                    value={this.state.activeSelected}
                                                />
                                            </Col>
                                        </Row>
                                        
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/master/punishment.html">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/master/punishment.html'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView